// features/devices/devicesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    routes: [],
    latitude: null,
    longitude: null,
    groups: []
};

const { reducer, actions } = createSlice({
    name: 'turbanapp',
    initialState,
    reducers: {
        setLat(state, action) {
            state.latitude = action.payload;
        },
        setLon(state, action) {
            state.longitude = action.payload;
        },
        setRoutes(state, action) {
            console.log(action.payload);

            state.routes = action.payload;
        },
        setGroups(state, action) {
            state.groups = action.payload;
        }
    }
});

// export const { setLimit, pushDevice, clearDevices } = devicesSlice.actions;
// export default devicesSlice.reducer;

export { actions as turbanActions, reducer as turbanReducer };

